import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

export { default as Alert } from './Alert.vue';

export const alertVariants = cva(
    'relative w-full rounded-xl border border-border-subdued-extra px-4 py-3 grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-5 [&>svg]:translate-y-0.5 [&>svg]:text-current',
    {
        variants: {
            variant: {
                default: 'bg-card text-card-foreground',
                neutral: 'bg-background-tertiary',
                destructive: 'bg-background-negative [&>svg]:text-content-negative',
                info: 'bg-background-informative [&>svg]:text-content-informative',
                warning: 'bg-background-warning [&>svg]:text-content-warning',
                positive: 'bg-background-positive [&>svg]:text-content-positive',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export type AlertVariants = VariantProps<typeof alertVariants>;
